import Button from "@components/ui/button";
import Icon from "@components/ui/icon";
import Spinner from "@components/ui/spinner";
import { useMediaLibDialogCtx } from "@editor/modules/media-lib/ctx";
import { useMediaLibDialogStoreShallow } from "@editor/modules/media-lib/stores";
import { cn } from "@lib/cn";

interface IProps {
  className?: string;
  submitLabel?: string;
}

export const MediaLibDialogMultiSelectPopover = ({
  className,
  submitLabel = "Use media",
}: IProps) => {
  const { onMultiSelect } = useMediaLibDialogCtx();
  const { items, isSubmitting, setSelectedItems } =
    useMediaLibDialogStoreShallow((s) => ({
      items: s.selectedItems,
      isSubmitting: s.isSubmitting,
      setSelectedItems: s.setSelectedItems,
    }));

  return (
    <div
      className={cn(
        "tw-absolute tw-bottom-2 tw-left-1/2 tw-z-50 tw-flex tw-w-fit -tw-translate-x-1/2 tw-items-center tw-rounded-lg tw-border tw-border-blue-50 tw-bg-white tw-p-2 tw-px-1 tw-py-[5px] tw-shadow-main tw-transition-opacity",
        items.length > 0 ? "tw-opacity-100" : "tw-opacity-0",
        className,
      )}
    >
      <button
        className={cn(
          "tw-ml-2 tw-outline-none ",
          isSubmitting && "tw-cursor-not-allowed",
        )}
        type="button"
        onClick={() => setSelectedItems([])}
        disabled={isSubmitting}
      >
        <Icon icon="ri-close-line" className="tw-mr-1.5 tw-text-blue-800" />
      </button>
      <span className="tw-text-[11px] tw-font-semibold tw-text-blue-800">
        Selected media: {items.length}
      </span>
      <Button
        size="xs"
        className={cn(
          "tw-ml-8 tw-flex tw-items-center",
          isSubmitting && "tw-cursor-wait",
        )}
        onClick={isSubmitting ? undefined : () => onMultiSelect(items)}
      >
        {isSubmitting ? (
          <>
            <Spinner className="tw-mr-1.5 tw-size-3 tw-border-white" />
            Adding media...
          </>
        ) : (
          submitLabel
        )}
      </Button>
    </div>
  );
};
